import UsersListView from "../presentation/views/UsersListView.vue";
import UserDetailView from "../presentation/views/UserDetailView.vue";
export const accessManagerRoutes = [
    {
        path: "/workspace/users",
        name: "AccessManagerUsers",
        component: UsersListView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "accessManager.users.title",
        },
    },
    {
        path: "/workspace/users/:userId",
        name: "AccessManagerUserDetail",
        component: UserDetailView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "accessManager.userDetail.title",
        },
    },
];
